var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#27D639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7502 11.9355C14.1951 11.9355 11.4441 16.9832 13.8614 20.8036C14.364 21.5979 15.0501 22.2562 15.8596 22.7241V28.2001H21.6408V22.7241C23.3775 21.7202 24.5314 19.8457 24.5314 17.7168C24.5314 14.529 21.938 11.9355 18.7502 11.9355ZM17.0158 27.0439V25.8876H20.4846V27.0439H17.0158ZM20.4846 22.0204V24.7314H19.3283V18.9897L20.8052 18.0051L20.1639 17.0431L18.7502 17.9855L17.3365 17.0431L16.6951 18.0051L18.1721 18.9897V24.7314H17.0158V22.0204L16.695 21.8609C15.1099 21.0731 14.1252 19.4852 14.1252 17.7168C14.1252 15.1666 16.2 13.0918 18.7502 13.0918C21.3004 13.0918 23.3752 15.1666 23.3752 17.7168C23.3752 20.8939 20.5321 21.9787 20.4846 22.0204Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2656 17.1387H28V18.2949H26.2656V17.1387Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.1387H11.2344V18.2949H9.5V17.1387Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6537 11.9951L24.8799 10.7689L25.6974 11.5864L24.4712 12.8126L23.6537 11.9951Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1719 8.4668H19.3281V10.2012H18.1719V8.4668Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8001 11.585L12.6176 10.7675L13.8438 11.9937L13.0263 12.8112L11.8001 11.585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIcon);
export default __webpack_public_path__ + "static/media/bulbIcon.c76faaea8ef9e3759547d094ce151f82.svg";
export { ForwardRef as ReactComponent };